import { render, staticRenderFns } from "./StorageEstimationIndex.vue?vue&type=template&id=25074ada&scoped=true&"
import script from "./StorageEstimationIndex.vue?vue&type=script&lang=js&"
export * from "./StorageEstimationIndex.vue?vue&type=script&lang=js&"
import style0 from "./StorageEstimationIndex.vue?vue&type=style&index=0&id=25074ada&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25074ada",
  null
  
)

export default component.exports